import { defaults } from 'helpers/cameras/coreCameraProps'
import { IMAGER_SIZES } from 'helpers/globals'

export default i => {
  const foundImagerSize = IMAGER_SIZES.find(iS => iS.text === i)
  return foundImagerSize ? foundImagerSize.value : defaults.imagerSize
}



// WEBPACK FOOTER //
// ./src/helpers/cameras/getImagerSize.js